<template>
  <div class="preview-article">
    <is-link
      :is_link="!loading"
      :href="href_to"
      :class="{loader: loading}"
      class="preview-article__img">
      <lazy-image
        v-if="!loading"
        :src="img_src"
        :lazy_src="lazy_img_src"
        cover_img
        :lazy_attr="lazy_attr"
        :class="img_lazy_class"
      />
    </is-link>
    <div class="preview-article__content">
      <component
        :is="title_tag"
        :class="{loader: loading}"
        class="preview-article__content-title">{{title}}
      </component>
      <html-block
        class="preview-article__content-text"
        :class="{loader: loading}"
        :content="text"/>
      <div class="preview-article__content_lower"
        :class="{loader: loading}">
        <template v-if="!loading">
          <a
            :href="href_to"
            class="preview-article__content_read-more">
            <arrow-right-circle-icon/>
            {{$t('text.read_more')}}...
          </a>
          <div class="preview-article__content_read-date">
            {{ get_date }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import LazyImage from "../../small_parts/LazyImage.vue";
import ArrowRightCircleIcon from "../../icons/ArrowRightCircleIcon.vue";
import HtmlBlock from "../../small_parts/HtmlBlock.vue";
import IsLink from "../../slots/IsLink.vue";

export const IMG_LAZY_CLASS = 'preview-article__img--lazy'
export default {
  name: "PreviewArticle",
  components: {IsLink, HtmlBlock, ArrowRightCircleIcon, LazyImage},
  props: {
    img_src: {
      type: String,
      default: '',
    },
    lazy_img_src: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    title_tag: {
      type: String,
      default: 'h4',
    },
    text: {
      type: String,
      default: '',
    },
    href_to: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
    lazy_attr: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    get_date() {
      if (!this.date) return ''
      let date = new Date(this.date)
      if (!(date instanceof Date)) return ''
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
    },
    img_lazy_class() {
      return IMG_LAZY_CLASS
    }
  }
}
</script>
